export default str => str.replace(/^(\w)/, m => m.toUpperCase());



// WEBPACK FOOTER //
// ./src/utils/capitalFirstLetter.js